var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 36,
    viewBox: "0 0 187 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.863 17.2901C102.863 7.75075 111.07 0 120.644 0C130.219 0 138.426 7.75075 138.426 17.2901C138.426 26.8295 130.219 34.5803 120.644 34.5803C111.07 34.5803 102.863 26.8295 102.863 17.2901ZM136.532 17.2901C136.532 8.6626 129.272 1.68342 120.644 1.68342C112.017 1.68342 104.757 8.6626 104.757 17.2901C104.757 25.9177 112.052 32.8968 120.644 32.8968C129.237 32.8968 136.532 25.9177 136.532 17.2901Z",
    fill: "#CA006C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3015 22.3752L64.8825 31.9146L60.4285 22.3752L50.6085 1.71826H48.6445L64.7773 35.562H64.9527L81.0855 1.71826H79.1215L69.3015 22.3752Z",
    fill: "#CA006C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.176 0.771568V17.3252L185.281 30.4068L156.453 0H156.242V34.6153H158.066V17.3252L157.996 4.24362L186.824 34.6153H187V0.771568H185.176Z",
    fill: "#CA006C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96399 34.6153H0L16.1328 0.981934H16.3432L32.4409 34.6153H30.4769L25.9878 25.1811H6.45311L1.96399 34.6153ZM7.15454 23.7432H25.2864L20.692 14.0284L16.2029 4.45399L11.7839 14.0284L7.15454 23.7783V23.7432Z",
    fill: "#CA006C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_1300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 35.5623,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvon);
export default __webpack_public_path__ + "static/media/Avon.6219d9baa176468ab260fc0cf7f2c1a7.svg";
export { ForwardRef as ReactComponent };